module.exports = __webpack_public_path__ + "img/1-06.3d5d2890.svg";